import React, {ReactNode} from 'react';

// react-scripts and the project ESLint resolver classify this new page into different groups.
// eslint-disable-next-line import/order
import {ComplaintsPage} from 'components/pages/Complaints';
import {ComplaintCreatePage} from 'components/pages/Complaints/Create';

import {ComplaintDetailPage} from 'components/pages/Complaints/Detail';
import {ComplaintProductDetailPage} from 'components/pages/Complaints/Detail/ProductDetail';
import {DashboardPage} from 'components/pages/Dashboard';
import {DeclarationsPage} from 'components/pages/Declarations';
import {DeclarationsAggregatedCodesPage} from 'components/pages/Declarations/AggregatedCodes';
import {DeclarationDetailsPage} from 'components/pages/Declarations/Details';
import {DeclarationsTransportCodesPage} from 'components/pages/Declarations/TransportCodes';
import {BlocksGridPage} from 'components/pages/Documents/BlocksGrid';
import {ChecksGridPage} from 'components/pages/Documents/ChecksGrid';
import {DocumentsGridPage, PageToRedirect} from 'components/pages/Documents/DocumentsGrid';
import {GDNew} from 'components/pages/Documents/GoodsDeclaration/GDNew';
import {GDPage} from 'components/pages/Documents/GoodsDeclaration/GDPage';
import {MovingGridPage} from 'components/pages/Documents/MovingGrid';
import {WithdrawalGridPage} from 'components/pages/Documents/WithdrawalGrid';
import {CreateAggregation} from 'components/pages/DocumentsCreate/Aggregation';
import {CreateBlocking} from 'components/pages/DocumentsCreate/Blocking';
import {CreateCommissioning} from 'components/pages/DocumentsCreate/Commissioning';

import {CreateConsumerReturn} from 'components/pages/DocumentsCreate/ConsumerReturn';
import {CreateDropOut} from 'components/pages/DocumentsCreate/DropOut';
import {CreateInvoiceNew} from 'components/pages/DocumentsCreate/InvoiceNew';
import {InvoicePrint} from 'components/pages/DocumentsCreate/InvoiceNew/Print';
import {CreateMoving} from 'components/pages/DocumentsCreate/Moving';
import {CreateRemarking} from 'components/pages/DocumentsCreate/Remarking';
import {TransferDocumentPage} from 'components/pages/DocumentsCreate/TransferDocument';
import {CreateUtilisation} from 'components/pages/DocumentsCreate/Utilisation';
import {DocumentsDetailsRouter} from 'components/pages/DocumentsDetails';
import {LoginPage} from 'components/pages/Login';
import {NoAccess} from 'components/pages/NoAccess';
import {CreateCustomerOrder} from 'components/pages/OrdersCreate/Customer';
import {CreateCustomsOrder} from 'components/pages/OrdersCreate/Customs';
import {CreateTransportOrder} from 'components/pages/OrdersCreate/Transport';
import {OrdersDetailPage} from 'components/pages/OrdersDetail';
import {OrdersGridPage} from 'components/pages/OrdersGrid';
import {ChangePasswordPage} from 'components/pages/Password/ChangePassword';
import {OTPPage} from 'components/pages/Password/OTP';
import {RequestResetPasswordPage} from 'components/pages/Password/RequestResetPassword';
import {ResetPasswordPage} from 'components/pages/Password/ResetPassword';
import {SetPasswordPage} from 'components/pages/Password/SetPassword';
import {ProductsDetailPage} from 'components/pages/ProductsDetail';
import {ProductsGridPage} from 'components/pages/ProductsGrid';
import {ProfilePage} from 'components/pages/Profile';
import {BillingHistory} from 'components/pages/Profile/Billing';
import {BranchesNk} from 'components/pages/Profile/BranchesNk';
import {BranchNkForm} from 'components/pages/Profile/BranchesNk/Form';
import {CustomsPage} from 'components/pages/Profile/Customs';
import {CreateCustoms} from 'components/pages/Profile/Customs/CreateCustoms';
import {UpdateCustoms} from 'components/pages/Profile/Customs/UpdateCustoms';
import {CustomsUsersByIdPage} from 'components/pages/Profile/Customs/Users';
import {CustomsUsersPage} from 'components/pages/Profile/CustomsUsers';
import {CreateCustomsUserPage} from 'components/pages/Profile/CustomsUsers/CreateUser';
import {UpdateCustomsUserPage} from 'components/pages/Profile/CustomsUsers/UpdateUser';
import {Factories} from 'components/pages/Profile/Factories/FactoriesGrid';
import {FactoryDetails} from 'components/pages/Profile/Factories/FactoryDetails';
import {FactoryLine} from 'components/pages/Profile/Factories/FactoryLineDetails';
import {Organizations} from 'components/pages/Profile/Organizations';
import {CreateOrganization} from 'components/pages/Profile/Organizations/CreateOrganization';
import {UpdateParticipant} from 'components/pages/Profile/Participants/UpdateParticipant';
import {PersonnelNk} from 'components/pages/Profile/PersonnelNk';
import {PersonnelNkEmployeeForm} from 'components/pages/Profile/PersonnelNk/EmployeeForm';
import {Staff} from 'components/pages/Profile/Staff';
import {CreateUser} from 'components/pages/Profile/Staff/CreateUser';
import {UpdateUser} from 'components/pages/Profile/Staff/UpdateUser';
import {Storages} from 'components/pages/Profile/Storages';
import {StorageDetails} from 'components/pages/Profile/Storages/StorageDetails';
import {RecallAuditDetailPage} from 'components/pages/RecallAudit/index';
import {ReceiptsDetail} from 'components/pages/ReceiptsDetail';
import {RegisterPage} from 'components/pages/Register';
import {GtinsGridPage} from 'components/pages/Registries/GtinsGrid';
import {RecallPage} from 'components/pages/Registries/RecallPage';
import {ProductsByOwnerReport} from 'components/pages/Reports/reports/ProductsByOwner';
import {ProductsByStatusesReport} from 'components/pages/Reports/reports/ProductsByStatuses';
import {TracingPage} from 'components/pages/Tracing';
import {TracingDetailPage} from 'components/pages/TracingDetail';
import {VirtualWarehouseWrapper} from 'components/pages/VirtualWarehouse';
import {PERMISSION_ALIASES} from 'core/constants/permissionAliases';
import {UserPermission, UserPermissionValue, UserRoles} from 'types';

import {BlockingAuditDetailPage, BlockingAuditLogPage} from '../components/pages/BlockingAudit';
import {CustomsAuditDetailPage, CustomsAuditLogPage} from '../components/pages/CustomsAudit';
import {CreateDisaggregation} from '../components/pages/DocumentsCreate/Disagregation';
import {ActivityLogPage, ProductCardAuditLogPage} from '../components/pages/ProductCardAudit';
import {ProductCardAuditDetailPage} from '../components/pages/ProductCardAudit/Detail';
import {RemarkingAuditDetailPage, RemarkingAuditLogPage} from '../components/pages/RemarkingAudit';
import {ReturnAuditDetailPage, ReturnAuditLogPage} from '../components/pages/ReturnAudit';
import {
    WithdrawalAuditDetailPage,
    WithdrawalAuditLogPage,
} from '../components/pages/WithdrawalAudit';

export interface RouteData {
    component: ReactNode;
    exact?: boolean;
    flex?: boolean;
    permissions?: UserPermissionValue[];
    permissionAccessRoles?: UserRoles[];
    roles?: UserRoles[];
    key?: string;
}

export enum ROUTE {
    TEST = '/test',
    LOGIN = '/login',
    REGISTER = '/register',
    SET_PASSWORD = '/set-password',
    RESET_PASSWORD = '/reset-password',
    REQUEST_RESET = '/request/reset',
    CHANGE_PASSWORD = '/profile/change-password',
    TWO_FA = '/2fa',
    DASHBOARD = '/dashboard',
    COMPLAINTS = '/complaints',
    COMPLAINTS_CREATE = '/complaints/create',
    COMPLAINTS_DETAIL = '/complaints/:id',
    COMPLAINTS_PRODUCT_DETAIL = '/complaints/:complaintId/code/:id',
    ORDERS_GRID = '/orders',
    ORDERS_CREATE_CUSTOMER = '/orders/create/customer',
    ORDERS_CREATE_TRANSPORT = '/orders/create/transport',
    ORDERS_CREATE_CUSTOMS = '/orders/create/customs',
    ORDERS_DETAIL = '/orders/:id',
    PRODUCTS_GRID = '/products',
    PRODUCTS_CONSUMER_GRID = '/products/consumer',
    PRODUCTS_TRANSPORT_GRID = '/products/transport',
    PRODUCTS_CUSTOMS_GRID = '/products/customs',
    DOCUMENTS_DOCUMENTS = '/documents',
    DOCUMENTS_MOVING = '/documents/moving',
    DOCUMENTS_WITHDRAWAL = '/documents/withdrawal',
    DOCUMENTS_INVOICES = '/invoices',
    DOCUMENTS_GDS = '/gds',
    DOCUMENTS_GDS_CREATE = '/gds/create',
    DOCUMENTS_GDS_DETAIL = '/gds/:id',
    DOCUMENTS_INVOICES_INCOMING = '/invoices/incoming',
    DOCUMENTS_INVOICES_OUTGOING = '/invoices/outgoing',
    DOCUMENTS_TRANSFER = '/documents/transfer',
    DOCUMENTS_TRANSFER_INCOMING = '/documents/transfer/incoming',
    DOCUMENTS_TRANSFER_OUTGOING = '/documents/transfer/outgoing',
    DOCUMENTS_CHECKS = '/receipts',
    DOCUMENTS_BLOCKING = '/documents/blocking',
    RECEIPTS_DETAIL = '/receipts/:id',
    DOCUMENTS_CREATE_DROP_OUT = '/documents/create/dropout',
    DOCUMENTS_CREATE_AGGREGATION = '/documents/create/aggregation',
    DOCUMENTS_CREATE_UTILISATION = '/documents/create/utilisation',
    DOCUMENTS_CREATE_COMMISSIONING = '/documents/create/commissioning',
    DOCUMENTS_CREATE_MOVING = '/documents/create/moving',
    DOCUMENTS_CREATE_INVOICE = '/documents/create/invoice',
    DOCUMENTS_CREATE_CONSUMER_RETURN = '/documents/create/consumer-return',
    DOCUMENTS_CREATE_REMARKING = '/documents/create/remarking',
    DOCUMENTS_CREATE_TRANSFER = '/documents/create/transfer-document',
    DOCUMENTS_CREATE_BLOCKING = '/documents/create/blocking',
    DOCUMENTS_CREATE_DISAGGREGATION = '/documents/create/disaggregation',
    DOCUMENTS_TRANSFER_DETAIL = '/documents/transfer/:id',
    DOCUMENTS_CONSUMER_RETURN_DETAIL = '/documents/consumer-return/:id',
    DOCUMENTS_CREATE_INVOICE_ID = '/documents/create/invoice/:invoiceId',
    PROFILE = '/profile',
    PROFILE_CREATE = '/profile/create',
    FACTORIES = '/profile/factories',
    FACTORY_DETAILS = '/profile/factories/:factoryId',
    FACTORY_LINE_DETAILS = '/profile/factories/:factoryId/:lineId',
    STAFF = '/profile/staff',
    STAFF_CREATE = '/profile/staff/create',
    STAFF_UPDATE = '/profile/staff/update',
    PERSONNEL_NK = '/profile/personnel-nk',
    PERSONNEL_NK_CREATE = '/profile/personnel-nk/create',
    PERSONNEL_NK_UPDATE = '/profile/personnel-nk/:id/edit',
    BRANCHES_NK = '/profile/branches-nk',
    BRANCHES_NK_CREATE = '/profile/branches-nk/create',
    BRANCHES_NK_UPDATE = '/profile/branches-nk/:id/edit',
    STORAGES = '/profile/storages',
    STORAGES_CREATE = '/profile/storages/create',
    STORAGES_DETAIL = '/profile/storages/:clientId',
    PRODUCTS_DETAIL = '/products/:id',
    DOCUMENTS_DETAIL = '/documents/:id',
    INVOICES_DETAIL = '/invoices/:id',
    INVOICES_PRINT = '/invoices/print/:id',
    REGISTRIES_GTIN = '/registries',
    RECALL_AUDIT = '/activity-log',
    RECALL_AUDIT_DETAIL = '/activity-log/recall/:id',
    PRODUCT_CARD_AUDIT = '/activity-log/product-cards',
    PRODUCT_CARD_AUDIT_DETAIL = '/activity-log/product-cards/:id',
    RETURN_AUDIT = '/activity-log/returns',
    RETURN_AUDIT_DETAIL = '/activity-log/returns/:id',
    WITHDRAWAL_AUDIT = '/activity-log/withdrawal',
    WITHDRAWAL_AUDIT_DETAIL = '/activity-log/withdrawal/:id',
    BLOCKING_AUDIT = '/activity-log/blocking',
    REMARKING_AUDIT = '/activity-log/remarking',
    REMARKING_AUDIT_DETAIL = '/activity-log/remarking/:id',
    BLOCKING_AUDIT_DETAIL = '/activity-log/blocking/:id',
    CUSTOMS_AUDIT = '/activity-log/customs',
    CUSTOMS_AUDIT_DETAIL = '/activity-log/customs/:id',
    REGISTRIES_GTIN_MY = '/registries/my',
    REGISTRIES_GTIN_MY_CREATED = '/registries/my-created',
    REGISTRIES_GTIN_ALL = '/registries/all',
    REGISTRIES_GTIN_USED = '/registries/used',
    REGISTRIES_GTIN_FAVORITES = '/registries/favorites',
    REGISTRIES_RECALL = '/registries/recall',
    VIRTUAL_WAREHOUSE = '/virtual_warehouse',
    VIRTUAL_WAREHOUSE_UNGROUPED = '/virtual_warehouse/ungrouped',
    EMPTY = '/empty',
    NO_ACCESS = '/no-access',
    REPORTS = '/reports',
    REPORT_PRODUCTS_BY_STATUSES = '/reports/products-by-statuses',
    REPORT_PRODUCTS_BY_OWNER = '/reports/products-by-owner',
    TRACING = '/tracing',
    TRACING_DETAIL = '/tracing/:id/:gtin',
    BILLING = '/profile/billing',
    BILLING_INVOICES = '/profile/invoices',
    ORGANIZATIONS = '/profile/organizations',
    ORGANIZATIONS_CREATE = '/profile/organizations/create',
    ORGANIZATIONS_DETAIL = '/profile/organizations/:id',
    DECLARATIONS = '/declarations',
    DECLARATION_DETAILS = '/declarations/document/:id',
    DECLARATION_TRANSPORT_CODES = '/declarations/document/:id/transport/:transportCode',
    DECLARATION_AGGREGATED_CODES = '/declarations/document/:id/transport/:transportCode/code/:markingCode',
    DOCUMENTS_GDS_DECLARATION_TRANSPORT_CODES = '/gds/:id/transport/:transportCode',
    DOCUMENTS_GDS_DECLARATION_AGGREGATED_CODES = '/gds/:id/transport/:transportCode/code/:markingCode',
    CUSTOMS = '/profile/customs',
    CUSTOMS_CREATE = '/profile/customs/create',
    CUSTOMS_UPDATE = '/profile/customs/update',
    CUSTOMS_USERS_LIST = '/profile/customs/users',
    CUSTOMS_USERS = '/profile/customs/:id/users',
    CUSTOMS_ID_USER_CREATE = '/profile/customs/:id/users/create',
    CUSTOMS_ID_USER_UPDATE = '/profile/customs/:id/users/update',
    CUSTOMS_USER_CREATE = '/profile/customs/users/create',
    CUSTOMS_USER_UPDATE = '/profile/customs/users/update',
}

export const PUBLIC_ROUTES_DATA: Record<string, RouteData> = {
    [ROUTE.LOGIN]: {
        component: <LoginPage />,
        exact: true,
    },
    [ROUTE.REGISTER]: {
        component: <RegisterPage />,
        exact: true,
    },
    [ROUTE.SET_PASSWORD]: {
        component: <SetPasswordPage />,
        exact: true,
    },
    [ROUTE.RESET_PASSWORD]: {
        component: <ResetPasswordPage />,
        exact: true,
    },
    [ROUTE.REQUEST_RESET]: {
        component: <RequestResetPasswordPage />,
        exact: true,
    },
    [ROUTE.TWO_FA]: {
        component: <OTPPage />,
        exact: true,
    },
};

export const CUSTOMS_ROUTES_DATA: Partial<Record<ROUTE, RouteData>> = {
    [ROUTE.DECLARATIONS]: {
        component: <DeclarationsPage />,
        exact: true,
        key: 'declarations',
        permissions: [UserPermission.CUSTOMS_DECLARATION_LIST],
    },
    [ROUTE.DECLARATION_DETAILS]: {
        component: <DeclarationDetailsPage />,
        exact: true,
        key: 'details',
        permissions: [UserPermission.CUSTOMS_DECLARATION_LIST],
    },
    [ROUTE.DECLARATION_TRANSPORT_CODES]: {
        component: <DeclarationsTransportCodesPage />,
        exact: true,
        key: 'transport',
        permissions: [UserPermission.CUSTOMS_DECLARATION_LIST],
    },
    [ROUTE.DECLARATION_AGGREGATED_CODES]: {
        component: <DeclarationsAggregatedCodesPage />,
        exact: true,
        key: 'aggregated',
        permissions: [UserPermission.CUSTOMS_DECLARATION_DETAILS],
    },
};

export const ROUTES_DATA: Partial<Record<ROUTE, RouteData>> = {
    // [ROUTE.TEST]: {
    //     component: <TestPage />,
    //     exact: false,
    // },
    [ROUTE.DASHBOARD]: {
        component: <DashboardPage />,
        exact: false,
    },
    [ROUTE.COMPLAINTS]: {
        component: <ComplaintsPage />,
        exact: true,
        permissions: [UserPermission.APPEAL_ALL_LIST, UserPermission.APPEAL_LIST],
    },
    [ROUTE.COMPLAINTS_CREATE]: {
        component: <ComplaintCreatePage />,
        exact: true,
        permissions: [UserPermission.APPEAL_CREATE],
    },
    [ROUTE.COMPLAINTS_DETAIL]: {
        component: <ComplaintDetailPage />,
        exact: true,
        permissions: [UserPermission.APPEAL_ALL_LIST, UserPermission.APPEAL_LIST],
    },
    [ROUTE.COMPLAINTS_PRODUCT_DETAIL]: {
        component: <ComplaintProductDetailPage />,
        exact: false,
        permissions: [UserPermission.APPEAL_ALL_LIST, UserPermission.APPEAL_LIST],
    },
    [ROUTE.ORDERS_GRID]: {
        component: <OrdersGridPage />,
        exact: true,
        permissions: [
            UserPermission.ORDER_CREATE_CUSTOMER,
            UserPermission.ORDER_CREATE_TRANSPORT,
            UserPermission.ORDER_CREATE_CUSTOMS,
        ],
    },
    // [ROUTE.REPORTS]: {
    //     component: <ReportsPage />,
    //     exact: true,
    // },
    [ROUTE.REPORT_PRODUCTS_BY_STATUSES]: {
        component: <ProductsByStatusesReport />,
        exact: false,
    },
    [ROUTE.REPORT_PRODUCTS_BY_OWNER]: {
        component: <ProductsByOwnerReport />,
        exact: false,
    },
    [ROUTE.ORDERS_CREATE_CUSTOMER]: {
        component: <CreateCustomerOrder />,
        exact: false,
        permissions: [UserPermission.ORDER_CREATE_CUSTOMER],
    },
    [ROUTE.ORDERS_CREATE_TRANSPORT]: {
        component: <CreateTransportOrder />,
        exact: false,
        permissions: [UserPermission.ORDER_CREATE_TRANSPORT],
    },
    [ROUTE.ORDERS_CREATE_CUSTOMS]: {
        component: <CreateCustomsOrder />,
        exact: false,
        permissions: [UserPermission.ORDER_CREATE_CUSTOMS],
    },
    [ROUTE.ORDERS_DETAIL]: {
        component: <OrdersDetailPage />,
        exact: false,
        permissions: [
            UserPermission.ORDER_CREATE_CUSTOMER,
            UserPermission.ORDER_CREATE_TRANSPORT,
            UserPermission.ORDER_CREATE_CUSTOMS,
        ],
    },
    [ROUTE.PRODUCTS_GRID]: {
        component: <PageToRedirect redirectTo={'/products/consumer'} />,
        exact: true,
        permissions: [UserPermission.PRODUCT_GRID_VIEW, UserPermission.ALL_PRODUCT_GRID_VIEW],
    },
    [ROUTE.PRODUCTS_CONSUMER_GRID]: {
        component: <ProductsGridPage />,
        exact: true,
        permissions: [UserPermission.PRODUCT_GRID_VIEW, UserPermission.ALL_PRODUCT_GRID_VIEW],
    },
    [ROUTE.PRODUCTS_TRANSPORT_GRID]: {
        component: <ProductsGridPage />,
        exact: true,
        permissions: [UserPermission.PRODUCT_GRID_VIEW, UserPermission.ALL_PRODUCT_GRID_VIEW],
    },
    [ROUTE.PRODUCTS_CUSTOMS_GRID]: {
        component: <ProductsGridPage />,
        exact: true,
        permissions: [UserPermission.PRODUCT_GRID_VIEW, UserPermission.ALL_PRODUCT_GRID_VIEW],
    },
    [ROUTE.PRODUCTS_DETAIL]: {
        component: <ProductsDetailPage />,
        exact: false,
        permissions: [
            UserPermission.PRODUCT_CARD_VIEW,
            UserPermission.RECEIPT_CARD_VIEW,
            UserPermission.PRODUCT_DETAIL_VIEW,
        ],
    },
    [ROUTE.DOCUMENTS_DOCUMENTS]: {
        component: <DocumentsGridPage />,
        exact: true,
        permissions: [UserPermission.DOCUMENT_GRID_VIEW],
    },
    [ROUTE.DOCUMENTS_MOVING]: {
        component: <MovingGridPage />,
        exact: true,
        permissions: [UserPermission.DOCUMENT_GRID_VIEW],
    },
    [ROUTE.DOCUMENTS_WITHDRAWAL]: {
        component: <WithdrawalGridPage />,
        exact: true,
        permissions: [UserPermission.DOCUMENT_VIEW_DROPOUT],
    },
    [ROUTE.DOCUMENTS_CREATE_DROP_OUT]: {
        component: <CreateDropOut />,
        exact: false,
        permissions: [UserPermission.DOCUMENT_CREATE_DROPOUT],
        permissionAccessRoles: [UserRoles.ROLE_MPL_OPERATOR_ADMIN],
    },
    [ROUTE.DOCUMENTS_CREATE_REMARKING]: {
        component: <CreateRemarking />,
        exact: true,
        permissions: [PERMISSION_ALIASES.remarking],
    },
    [ROUTE.DOCUMENTS_CREATE_TRANSFER]: {
        component: <TransferDocumentPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_CREATE_BLOCKING]: {
        component: <CreateBlocking />,
        exact: true,
        permissions: [UserPermission.MPL_BLOCKING_CREATE],
    },
    [ROUTE.DOCUMENTS_CREATE_DISAGGREGATION]: {
        component: <CreateDisaggregation />,
        exact: true,
        permissions: [PERMISSION_ALIASES.disaggregationCreate],
    },
    [ROUTE.DOCUMENTS_CREATE_UTILISATION]: {
        component: <CreateUtilisation />,
        exact: false,
        permissions: [UserPermission.DOCUMENT_CREATE_UTILISATION],
    },
    [ROUTE.DOCUMENTS_CREATE_AGGREGATION]: {
        component: <CreateAggregation />,
        exact: false,
        permissions: [UserPermission.DOCUMENT_CREATE_AGGREGATION],
    },
    [ROUTE.DOCUMENTS_CREATE_COMMISSIONING]: {
        component: <CreateCommissioning />,
        exact: false,
        permissions: [UserPermission.DOCUMENT_CREATE_COMMISSIONING],
    },
    [ROUTE.DOCUMENTS_CREATE_INVOICE]: {
        component: <CreateInvoiceNew />,
        exact: true,
    },
    [ROUTE.DOCUMENTS_CREATE_CONSUMER_RETURN]: {
        component: <CreateConsumerReturn />,
        exact: false,
    },
    [ROUTE.INVOICES_PRINT]: {
        component: <InvoicePrint />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_CREATE_INVOICE_ID]: {
        component: <CreateInvoiceNew />,
        exact: false,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_CREATE_MOVING]: {
        component: <CreateMoving />,
        exact: false,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_TRANSFER]: {
        component: <PageToRedirect redirectTo={ROUTE.DOCUMENTS_TRANSFER_INCOMING} />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_TRANSFER_INCOMING]: {
        component: <DocumentsGridPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_TRANSFER_OUTGOING]: {
        component: <DocumentsGridPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_TRANSFER_DETAIL]: {
        component: <TransferDocumentPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_BLOCKING]: {
        component: <BlocksGridPage />,
        exact: true,
        permissions: [UserPermission.MPL_BLOCKING_LIST_VIEW],
    },
    [ROUTE.DOCUMENTS_DETAIL]: {
        component: <DocumentsDetailsRouter />,
        exact: false,
        permissions: [UserPermission.DOCUMENT_DETAIL_VIEW],
    },
    [ROUTE.DOCUMENTS_CHECKS]: {
        component: <ChecksGridPage />,
        exact: true,
        permissions: [UserPermission.RECEIPT_GRID_VIEW, UserPermission.ALL_PRODUCT_GRID_VIEW],
    },
    [ROUTE.DOCUMENTS_INVOICES]: {
        component: <PageToRedirect redirectTo={'/invoices/incoming'} />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_GDS]: {
        component: <GDPage />,
        exact: true,
        key: 'gds',
        permissions: [UserPermission.DOCUMENTS_DECLARATION_LIST],
    },
    [ROUTE.DOCUMENTS_GDS_CREATE]: {
        component: <GDNew />,
        exact: true,
        permissions: [UserPermission.DOCUMENTS_DECLARATION_CREATE],
    },
    [ROUTE.DOCUMENTS_GDS_DETAIL]: {
        component: <GDNew />,
        exact: true,
        key: 'gds_declaration',
        permissions: [UserPermission.DOCUMENTS_DECLARATION_DETAILS],
    },
    [ROUTE.DOCUMENTS_GDS_DECLARATION_TRANSPORT_CODES]: {
        component: <DeclarationsTransportCodesPage isGds />,
        exact: true,
        key: 'transport',
        permissions: [UserPermission.DOCUMENTS_DECLARATION_DETAILS],
    },
    [ROUTE.DOCUMENTS_GDS_DECLARATION_AGGREGATED_CODES]: {
        component: <DeclarationsAggregatedCodesPage />,
        exact: true,
        key: 'aggregated',
        permissions: [UserPermission.DOCUMENTS_DECLARATION_DETAILS],
    },
    [ROUTE.DOCUMENTS_INVOICES_INCOMING]: {
        component: <DocumentsGridPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.DOCUMENTS_INVOICES_OUTGOING]: {
        component: <DocumentsGridPage />,
        exact: true,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.INVOICES_DETAIL]: {
        component: <CreateInvoiceNew />,
        exact: false,
        permissions: [UserPermission.INVOICE_TRANSFER_VIEW],
    },
    [ROUTE.RECEIPTS_DETAIL]: {
        component: <ReceiptsDetail />,
        exact: false,
        permissions: [UserPermission.RECEIPT_CARD_VIEW],
    },
    [ROUTE.PROFILE]: {
        component: <ProfilePage />,
        exact: true,
        permissions: [UserPermission.PROFILE_DATA_VIEW],
    },
    [ROUTE.PROFILE_CREATE]: {
        component: <UpdateParticipant />,
        exact: true,
        permissions: [UserPermission.PROFILE_DATA_VIEW],
    },
    [ROUTE.FACTORIES]: {
        component: <Factories />,
        exact: true,
        permissions: [UserPermission.FACTORY_GRID_VIEW],
    },
    [ROUTE.FACTORY_DETAILS]: {
        component: <FactoryDetails />,
        exact: true,
        permissions: [UserPermission.FACTORY_CARD_VIEW],
    },
    [ROUTE.FACTORY_LINE_DETAILS]: {
        component: <FactoryLine />,
        exact: false,
        permissions: [UserPermission.FACTORY_CARD_VIEW],
    },
    [ROUTE.CUSTOMS]: {
        component: <CustomsPage />,
        exact: true,
        permissions: [UserPermission.CUSTOMS_LIST],
    },
    [ROUTE.CUSTOMS_CREATE]: {
        component: <CreateCustoms />,
        exact: false,
    },
    [ROUTE.CUSTOMS_UPDATE]: {
        component: <UpdateCustoms />,
        exact: false,
    },
    [ROUTE.CUSTOMS_USERS_LIST]: {
        component: <CustomsUsersPage />,
        exact: true,
        permissions: [UserPermission.CUSTOMS_EMPLOYEE_LIST],
    },
    [ROUTE.CUSTOMS_USERS]: {
        component: <CustomsUsersByIdPage />,
        exact: true,
        permissions: [UserPermission.CUSTOMS_EMPLOYEE_LIST],
    },
    [ROUTE.CUSTOMS_ID_USER_CREATE]: {
        component: <CreateCustomsUserPage />,
        exact: true,
        permissions: [UserPermission.CUSTOMS_EMPLOYEE_CREATE],
    },
    [ROUTE.CUSTOMS_ID_USER_UPDATE]: {
        component: <UpdateCustomsUserPage />,
        exact: true,
    },
    [ROUTE.CUSTOMS_USER_CREATE]: {
        component: <CreateCustomsUserPage />,
        exact: true,
        permissions: [UserPermission.CUSTOMS_EMPLOYEE_CREATE],
    },
    [ROUTE.CUSTOMS_USER_UPDATE]: {
        component: <UpdateCustomsUserPage />,
        exact: true,
    },
    [ROUTE.STAFF]: {
        component: <Staff />,
        exact: true,
    },
    [ROUTE.STAFF_CREATE]: {
        component: <CreateUser />,
        exact: false,
        permissions: [PERMISSION_ALIASES.userOwnRegister, PERMISSION_ALIASES.userAllRegister],
    },
    [ROUTE.STAFF_UPDATE]: {
        component: <UpdateUser />,
        exact: false,
        permissions: [PERMISSION_ALIASES.userOwnEdit, PERMISSION_ALIASES.userAllEdit],
    },
    [ROUTE.PERSONNEL_NK]: {
        component: <PersonnelNk />,
        exact: true,
        permissions: [PERMISSION_ALIASES.personnelNk],
    },
    [ROUTE.PERSONNEL_NK_CREATE]: {
        component: <PersonnelNkEmployeeForm mode="create" />,
        exact: true,
        permissions: [PERMISSION_ALIASES.personnelNk],
    },
    [ROUTE.PERSONNEL_NK_UPDATE]: {
        component: <PersonnelNkEmployeeForm mode="edit" />,
        exact: true,
        permissions: [PERMISSION_ALIASES.personnelNk],
    },
    [ROUTE.BRANCHES_NK]: {
        component: <BranchesNk />,
        exact: true,
        permissions: [PERMISSION_ALIASES.nkBranchManage],
    },
    [ROUTE.BRANCHES_NK_CREATE]: {
        component: <BranchNkForm mode="create" />,
        exact: true,
        permissions: [PERMISSION_ALIASES.nkBranchManage],
    },
    [ROUTE.BRANCHES_NK_UPDATE]: {
        component: <BranchNkForm mode="edit" />,
        exact: true,
        permissions: [PERMISSION_ALIASES.nkBranchManage],
    },
    [ROUTE.STORAGES]: {
        component: <Storages />,
        exact: true,
    },
    [ROUTE.STORAGES_CREATE]: {
        component: <StorageDetails mode="create" />,
        exact: true,
        permissions: [
            PERMISSION_ALIASES.organizationParticipantOwnRegister,
            PERMISSION_ALIASES.participantAllRegister,
        ],
    },
    [ROUTE.STORAGES_DETAIL]: {
        component: <StorageDetails mode="details" />,
        exact: true,
    },
    [ROUTE.BILLING]: {
        component: <BillingHistory />,
        exact: false,
        permissions: [UserPermission.FACTORY_BILLING_VIEW],
    },
    [ROUTE.BILLING_INVOICES]: {
        component: <BillingHistory />,
        exact: false,
        roles: [UserRoles.ROLE_MPL_OPERATOR_ADMIN],
    },
    [ROUTE.ORGANIZATIONS]: {
        component: <Organizations />,
        exact: true,
        permissions: [PERMISSION_ALIASES.registeredTurnoverParticipantsView],
    },
    [ROUTE.ORGANIZATIONS_CREATE]: {
        component: <CreateOrganization />,
        exact: false,
        permissions: [PERMISSION_ALIASES.organizationRegister],
    },
    [ROUTE.ORGANIZATIONS_DETAIL]: {
        component: <CreateOrganization />,
        exact: false,
        permissions: [PERMISSION_ALIASES.organizationRegister],
    },
    [ROUTE.REGISTRIES_GTIN]: {
        component: <PageToRedirect redirectTo={ROUTE.REGISTRIES_GTIN_FAVORITES} />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.RECALL_AUDIT]: {
        component: <ActivityLogPage />,
        exact: true,
        permissions: [
            PERMISSION_ALIASES.recallAuditLogView,
            PERMISSION_ALIASES.productCardAuditLogView,
            PERMISSION_ALIASES.returnAuditLogView,
            PERMISSION_ALIASES.withdrawalAuditLogView,
            PERMISSION_ALIASES.blockingAuditLogView,
            PERMISSION_ALIASES.remarkingAuditLogView,
            PERMISSION_ALIASES.customsAuditLogView,
        ],
    },
    [ROUTE.BLOCKING_AUDIT]: {
        component: <BlockingAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.blockingAuditLogView],
    },
    [ROUTE.REMARKING_AUDIT]: {
        component: <RemarkingAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.remarkingAuditLogView],
    },
    [ROUTE.REMARKING_AUDIT_DETAIL]: {
        component: <RemarkingAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.remarkingAuditLogView],
    },
    [ROUTE.BLOCKING_AUDIT_DETAIL]: {
        component: <BlockingAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.blockingAuditLogView],
    },
    [ROUTE.CUSTOMS_AUDIT]: {
        component: <CustomsAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.customsAuditLogView],
    },
    [ROUTE.CUSTOMS_AUDIT_DETAIL]: {
        component: <CustomsAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.customsAuditLogView],
    },
    [ROUTE.WITHDRAWAL_AUDIT]: {
        component: <WithdrawalAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.withdrawalAuditLogView],
    },
    [ROUTE.WITHDRAWAL_AUDIT_DETAIL]: {
        component: <WithdrawalAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.withdrawalAuditLogView],
    },
    [ROUTE.RETURN_AUDIT]: {
        component: <ReturnAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.returnAuditLogView],
    },
    [ROUTE.RETURN_AUDIT_DETAIL]: {
        component: <ReturnAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.returnAuditLogView],
    },
    [ROUTE.PRODUCT_CARD_AUDIT]: {
        component: <ProductCardAuditLogPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.productCardAuditLogView],
    },
    [ROUTE.PRODUCT_CARD_AUDIT_DETAIL]: {
        component: <ProductCardAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.productCardAuditLogView],
    },
    [ROUTE.RECALL_AUDIT_DETAIL]: {
        component: <RecallAuditDetailPage />,
        exact: true,
        permissions: [PERMISSION_ALIASES.recallAuditLogView],
    },
    [ROUTE.REGISTRIES_RECALL]: {
        component: <RecallPage />,
        exact: true,
        roles: [
            UserRoles.ROLE_MPL_OPERATOR_ADMIN,
            UserRoles.ROLE_MPL_MANUFACTURER_DIRECTOR,
            UserRoles.ROLE_MPL_MANUFACTURER_EMPLOYEE,
            UserRoles.ROLE_MPL_IMPORTER_DIRECTOR,
            UserRoles.ROLE_MPL_IMPORTER_EMPLOYEE,
        ],
    },
    [ROUTE.REGISTRIES_GTIN_MY]: {
        component: <PageToRedirect redirectTo={ROUTE.REGISTRIES_GTIN_FAVORITES} />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.REGISTRIES_GTIN_MY_CREATED]: {
        component: <GtinsGridPage />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.REGISTRIES_GTIN_ALL]: {
        component: <GtinsGridPage />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.REGISTRIES_GTIN_USED]: {
        component: <GtinsGridPage />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.REGISTRIES_GTIN_FAVORITES]: {
        component: <GtinsGridPage />,
        exact: true,
        permissions: [UserPermission.GTIN_GRID_VIEW, UserPermission.ALL_GTIN_GRID_VIEW],
    },
    [ROUTE.VIRTUAL_WAREHOUSE]: {
        component: <VirtualWarehouseWrapper />,
        permissions: [UserPermission.VIRTUAL_WAREHOUSE_VIEW],
    },
    [ROUTE.TRACING]: {
        component: <TracingPage />,
        exact: true,
    },
    [ROUTE.TRACING_DETAIL]: {
        component: <TracingDetailPage />,
        exact: false,
        flex: true,
    },
    [ROUTE.CHANGE_PASSWORD]: {
        component: <ChangePasswordPage />,
        exact: true,
    },
    [ROUTE.EMPTY]: {
        component: null,
        exact: true,
    },
    [ROUTE.NO_ACCESS]: {
        component: <NoAccess />,
        exact: true,
    },
    ...CUSTOMS_ROUTES_DATA,
};
